<script>
  import { faqSection } from './faq.js';

  let openItems = new Set([0]);

  const toggleItem = (index) => {
    const nextOpenItems = new Set(openItems);

    if (nextOpenItems.has(index)) {
      nextOpenItems.delete(index);
    } else {
      nextOpenItems.add(index);
    }

    openItems = nextOpenItems;
  };
</script>

<section id="questions" class="faq-section" aria-labelledby="faq-title">
  <div class="faq-inner">
    <div class="faq-content">
      <h2 id="faq-title">{faqSection.title}</h2>

      <div class="faq-list">
        {#each faqSection.items as item, index}
          <article class="faq-item" class:is-open={openItems.has(index)}>
            <button
              class="faq-question"
              type="button"
              aria-expanded={openItems.has(index)}
              aria-controls={`faq-answer-${index}`}
              on:click={() => toggleItem(index)}
            >
              <span>{item.question}</span>
              <span class="faq-arrow" aria-hidden="true"></span>
            </button>

            {#if openItems.has(index)}
              <div id={`faq-answer-${index}`} class="faq-answer">
                {#each item.answer as paragraph}
                  <p>{paragraph}</p>
                {/each}
              </div>
            {/if}
          </article>
        {/each}
      </div>
    </div>
  </div>
</section>

<style>
  .faq-section {
    display: flex;
    justify-content: center;
    padding: 100px 0;
    background: #111111;
    color: #ffffff;
    font-family: Roboto, Arial, Helvetica, sans-serif;
    font-variation-settings: 'wdth' 100;
  }

  .faq-inner {
    display: flex;
    width: min(100%, 1440px);
    justify-content: center;
    padding: 0 64px;
    box-sizing: border-box;
  }

  .faq-content {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 48px;
    padding: 0 12px;
    box-sizing: border-box;
  }

  h2,
  p {
    margin: 0;
  }

  h2 {
    color: #ffffff;
    font-size: 56px;
    font-weight: 800;
    line-height: 56px;
  }

  .faq-list {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }

  .faq-item {
    width: 100%;
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    box-sizing: border-box;
  }

  .faq-question {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    padding: 24px 0;
    border: 0;
    background: transparent;
    color: #ffffff;
    font: inherit;
    cursor: pointer;
    text-align: left;
    box-sizing: border-box;
  }

  .faq-question span:first-child {
    min-width: 0;
    color: #ffffff;
    font-size: 26px;
    font-weight: 500;
    line-height: 32px;
  }

  .faq-arrow {
    position: relative;
    width: 24px;
    height: 24px;
    flex: 0 0 24px;
  }

  .faq-arrow::before {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 10px;
    height: 10px;
    border-top: 2px solid #ffffff;
    border-left: 2px solid #ffffff;
    content: '';
    /* Open = chevron вверх (45°), closed = chevron вниз (225°).
       translate -25%/-65% компенсируют визуальный центр border-chevron'а
       (масса в углу пересечения двух border'ов, не в геом-центре). */
    transform: translate(-50%, -25%) rotate(45deg);
    transition: transform 160ms ease;
  }

  .faq-item:not(.is-open) .faq-arrow::before {
    transform: translate(-50%, -65%) rotate(225deg);
  }

  .faq-answer {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 0;
    padding: 0 24px 24px;
    box-sizing: border-box;
  }

  .faq-answer p {
    color: #ffffff;
    font-size: 22px;
    font-weight: 500;
    line-height: 32px;
  }

  @media (max-width: 1279px) {
    .faq-inner {
      padding: 0 32px;
    }

    .faq-content {
      padding: 0 12px;
    }

    h2 {
      font-size: 40px;
      line-height: 1.1;
    }
  }

  @media (max-width: 1599px) and (min-width: 1280px) {
    h2 {
      font-size: 48px;
      line-height: 1.1;
    }
  }

  @media (max-width: 767px) {
    .faq-section {
      padding: 40px 0;
    }

    .faq-inner {
      padding: 0 24px;
    }

    .faq-content {
      padding: 0;
    }

    h2 {
      font-size: 32px;
      line-height: 56px;
    }

    .faq-question {
      padding: 24px 0;
    }

    .faq-question span:first-child {
      font-size: 18px;
      line-height: normal;
    }

    .faq-answer {
      padding: 0 24px 24px;
    }

    .faq-answer p {
      font-size: 16px;
      line-height: normal;
    }
  }
</style>
